
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class SubCategoryMasterGrid extends Serenity.EntityGrid<SubCategoryMasterRow, any> {
        protected getColumnsKey() { return 'OMS.SubCategoryMaster'; }
        protected getDialogType() { return SubCategoryMasterDialog; }
        protected getIdProperty() { return SubCategoryMasterRow.idProperty; }
        protected getLocalTextPrefix() { return SubCategoryMasterRow.localTextPrefix; }
        protected getService() { return SubCategoryMasterService.baseUrl; }
        protected getInsertPermission() { return SubCategoryMasterRow.insertPermission; }
        protected getUpdatePermission() { return SubCategoryMasterRow.updatePermission; }
        protected getDeletePermission() { return SubCategoryMasterRow.deletePermission; }
        protected useViewMode() { return true; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}